var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A476F",
    d: "m.003 20.997 2.8 3.282.251-.3V2.99l-.251-.317-2.8 3.28v15.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F5B98",
    d: "m2.803 24.278 5.35 2.675.223-.358L8.38.28 8.157 0 2.803 2.666v21.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D72B8",
    d: "m23.92 5.953-2.801-3.28-.314.1.063 21.238.25.268 2.802-3.282V5.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5294CF",
    d: "m15.768 26.953 5.35-2.675V2.666L15.765 0l-.253.343.004 26.221.253.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D72B8",
    d: "M8.157 0h7.607v26.954H8.157V0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.922v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRds);
export default __webpack_public_path__ + "static/media/RDS.2ac3a1630c6ffd740576a0fd90522844.svg";
export { ForwardRef as ReactComponent };